import React from "react";

const UserInformation = ({ profile, setProfile, countries }) => {
  return (
    <div className="space-y-6">
      {/* Permissions */}
      <div className="mt-4 space-y-2">
        <label className="block font-semibold text-accent mb-2">Show Info To Others</label>
        <label className="inline-flex items-center space-x-2">
          <input
            type="checkbox"
			disabled={!setProfile}
            checked={profile.permissions?.show_passport || false}
            onChange={(e) =>
              setProfile({
                ...profile,
                permissions: {
                  ...profile.permissions,
                  show_passport: e.target.checked,
                },
              })
            }
          />
          <span>Show passport info to trip members</span>
        </label>
        <label className="inline-flex items-center space-x-2">
          <input
            type="checkbox"
			disabled={!setProfile}
            checked={profile.permissions?.show_memberships || false}
            onChange={(e) =>
              setProfile({
                ...profile,
                permissions: {
                  ...profile.permissions,
                  show_memberships: e.target.checked,
                },
              })
            }
          />
          <span>Show frequent flyer info to trip members</span>
        </label>
      </div>	
      {/* Birth Date */}
      <div>
        <label className="block font-semibold text-accent mb-2">Birth Date</label>
        <input
          type="date"
          value={profile.birth_date || ""}
          onChange={(e) => setProfile({ ...profile, birth_date: e.target.value })}
		  disabled={!setProfile}
          className="border rounded-md p-2 w-full"
        />
      </div>

      {/* Passport Info */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        <div>
          <label className="block font-semibold text-accent mb-2">Passport Name</label>
          <input
            type="text"
            value={profile.full_name || ""}
            onChange={(e) => setProfile({ ...profile, full_name: e.target.value })}
			disabled={!setProfile}
            className="border rounded-md p-2 w-full"
            placeholder="Enter full name"
          />
        </div>
        <div>
          <label className="block font-semibold text-accent mb-2">Passport Country</label>
          <select
            value={profile.passport_country || ""}
            onChange={(e) => setProfile({ ...profile, passport_country: e.target.value })}
			disabled={!setProfile}
            className="border rounded-md p-2 w-full"
          >
            <option value="">Select Country</option>
            {countries.map((c) => (
              <option key={c.id} value={c.name}>{c.name}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block font-semibold text-accent mb-2">Passport Number</label>
          <input
            type="text"
            value={profile.passport_number || ""}
            onChange={(e) => setProfile({ ...profile, passport_number: e.target.value })}
			disabled={!setProfile}
            className="border rounded-md p-2 w-full"
            placeholder="Enter passport number"
          />
        </div>
        <div>
          <label className="block font-semibold text-accent mb-2">Passport Expire Date</label>
          <input
            type="date"
            value={profile.passport_info || ""}
            onChange={(e) => setProfile({ ...profile, passport_info: e.target.value })}
			disabled={!setProfile}
            className="border rounded-md p-2 w-full"
          />
        </div>
      </div>

      {/* Airline Memberships */}
      <div>
        <label className="block font-semibold text-accent mb-2">Airline Memberships</label>
        {Object.entries(profile.airline_memberships || {}).map(([program, number], index) => (
          <div key={index} className="flex gap-2 mb-2">
            <input
              type="text"
              value={program}
              onChange={(e) => {
                const newMemberships = { ...profile.airline_memberships };
                const val = e.target.value;
                delete newMemberships[program];
                newMemberships[val] = number;
                setProfile({ ...profile, airline_memberships: newMemberships });
              }}
              placeholder="Program"
			  disabled={!setProfile}
              className="border rounded-md p-2 w-1/2"
            />
            <input
              type="text"
              value={number}
              onChange={(e) => {
                const newMemberships = { ...profile.airline_memberships };
                newMemberships[program] = e.target.value;
                setProfile({ ...profile, airline_memberships: newMemberships });
              }}
              placeholder="Membership #"
			  disabled={!setProfile}
              className="border rounded-md p-2 w-1/2"
            />
          </div>
        ))}
        <button
          onClick={() => {
            setProfile({
              ...profile,
              airline_memberships: {
                ...profile.airline_memberships,
                "": "",
              },
            });
          }}
          className="text-blue-600 hover:underline text-sm mt-2"
        >
          + Add Membership
        </button>
      </div>
    </div>
  );
};

export default UserInformation;
